const EditableField = ({ 
  label, 
  value, 
  onChange, 
  isEditMode, 
  required = false, 
  error = null,
  type = 'text',
  placeholder = '',
  disabled = false,
  options = null // For select fields
}) => {
  if (!isEditMode) {
    // Read-only display
    return (
      <div className="datagrid-item">
        <div className="datagrid-title">{label}</div>
        <div className="datagrid-content">{value || '-'}</div>
      </div>
    );
  }

  // Edit mode
  return (
    <div className="mb-3">
      <label className={`form-label ${required ? 'required' : ''}`}>
        {label}
        {required && <span className="text-danger ms-1">*</span>}
      </label>
      {options ? (
        <select
          className={`form-select ${error ? 'is-invalid' : ''}`}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          disabled={disabled}
        >
          <option value="">Select {label}...</option>
          {options.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          className={`form-control ${error ? 'is-invalid' : ''}`}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          disabled={disabled}
        />
      )}
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default EditableField;
